import { Link2 } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { dateTime } from "@/components/cockpit/meta";

const LeadPicker = ({ onPick }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return undefined; }
    const t = setTimeout(() => api.post("/pipeline/search", { q, limit: 8 }).then(({ data }) => setRes(data.rows || [])).catch(() => {}), 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <span className="ck-picker">
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher la fiche (nom, n°)…" data-testid="ck-attach-search" />
      {res.length > 0 && <span className="ck-picker-list">{res.map((r) => <button key={r.lead_id} type="button" onClick={() => onPick(r)} data-testid={`ck-attach-pick-${r.lead_id}`}>{r.title}<small>{r.step}</small></button>)}</span>}
    </span>
  );
};

const STATUS = { answered: "décroché", missed: "manqué", voicemail: "messagerie", no_answer: "non décroché" };

export const UnattachedCalls = ({ period, range, onChanged }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  const [pages, setPages] = useState(1);
  const load = useCallback(() => api.get("/ringover/unattached", { params: { period, ...(period === "custom" ? range : {}), limit: 100 * pages } }).then(({ data: d }) => setData(d)).catch(() => setData({ calls: [], total: 0 })), [period, range, pages]);
  useEffect(() => { load(); }, [load]);
  const attach = async (call, lead) => {
    try {
      await api.post(`/ringover/calls/${call.call_id}/attach`, { lead_id: lead.lead_id });
      toast.success(`Appel rattaché à « ${lead.title} ».`);
      setOpen(null);
      load();
      onChanged?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Rattachement impossible."); }
  };
  if (!data) return <p className="ck-muted">Chargement…</p>;
  return (
    <div className="ck-list" data-testid="ck-unattached">
      <p className="ck-muted">{data.total.toLocaleString("fr-FR")} appel(s) Ringover sans fiche ni contact de fichier sur la période.</p>
      {data.calls.map((c) => (
        <div key={c.call_id} className="ck-unatt" data-testid={`ck-unatt-${c.call_id}`}>
          <span><strong>{c.contact_number || "Numéro masqué"}</strong><small className="ck-muted"> · {c.direction === "in" ? "entrant" : "sortant"} · {STATUS[c.status] || c.status || ""} · {c.duration || 0} s · {c.user_name || ""}{c.tags?.length ? ` · ${c.tags.join(", ")}` : ""}</small></span>
          <span className="ck-muted">{dateTime(c.started_at)}</span>
          {open === c.call_id ? <LeadPicker onPick={(lead) => attach(c, lead)} /> : <button type="button" className="ck-reset" onClick={() => setOpen(c.call_id)} data-testid={`ck-attach-${c.call_id}`}><Link2 size={13} /> Rattacher</button>}
        </div>
      ))}
      {data.calls.length < data.total && <button type="button" className="ck-reset" onClick={() => setPages(pages + 1)} data-testid="ck-unatt-more">Voir 100 appels de plus</button>}
    </div>
  );
};
